import { render, staticRenderFns } from "./PersonnelAnalysis.vue?vue&type=template&id=31b908ec&scoped=true&"
import script from "./PersonnelAnalysis.vue?vue&type=script&lang=js&"
export * from "./PersonnelAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./PersonnelAnalysis.vue?vue&type=style&index=0&id=31b908ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b908ec",
  null
  
)

export default component.exports